<template>
  <form id="token-form" class="flex flex-col gap-10 items-center">

    <div class="flex flex-row items-center justify-center pt-10">
      <span class="mdn-Icon-mensagem-sms mdn-Icon--lg -mr-3 -mt-10 z-10"></span>
      <span class=" flex items-center justify-center mdn-Icon-celular mdn-Icon--md bg-gray-200 rounded-full w-10 h-10"></span>
    </div>

    <MdnInput
      name="otp"
      placeholder="Código de verificação"
      type="text"
      errorFeedback="Código de verificação inválido"
      required
      maxlength=8
      v-on:input="getInputValue"
      mask="9999?9?9?9?9"
    />
    <mdn-heading :level="3">
      {{ msisdnMasked }}
    </mdn-heading>

    <mdn-text v-if="error" class="text-red-500">
      {{ error }}
    </mdn-text>

    <Button
      primary
      id="otp-confirm"
      type="button"
      :disabled="hasError"
      @click="submit">Continuar
    </Button>

  </form>
</template>

<script>
import { isEmpty } from 'common/utils'
import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'
import { manageIsTelevendasMixin } from './../../business/televendas/mixins'
import store from '@/business/store'
import { SHOULD_HIDE_BACK_BUTTONS } from '@/common/constants'
import { Button, MdnText, MdnHeading } from 'mondrian-vue'
import MdnInput from '../../components/MdnInput.vue'
import { maskJs } from 'mask-js'

export default {
  name: 'TokenForm',
  components: { Button, MdnInput, MdnText, MdnHeading },
  props: {
    error: [Boolean, String],
    msisdn: String
  },
  data: () => ({
    token: '',
    touched: false,
    showBackButton: true
  }),
  mixins: [
    manageIsTelevendasMixin
  ],
  computed: {
    hasError () {
      const { token } = this
      return isEmpty(token)
    },
    showError () {
      return this.hasError && this.touched
    },
    msisdnMasked () {
      return maskJs('(99) 9 9999-9999', onlyNumbers(this.msisdn))
    }
  },
  methods: {
    getInputValue (event) {
      this.touched = true
      this.token = onlyNumbers(event.value)
    },
    onInput (event) {
      this.touched = true
      this.token = onlyNumbers(event.target.value)
    },
    submit () {
      this.$emit('submit', this.token)
    },
    setShowBackButton (flag) { this.showBackButton = flag }
  },
  async created () {
    const shouldHideButton = !!(await store.get(SHOULD_HIDE_BACK_BUTTONS))
    if (shouldHideButton) this.setShowBackButton(false)
  },
  async mounted () {
    try {
      const isTelevendas = await this.loadIsTelevendas()
      if (isTelevendas) this.setShowBackButton(false)
    } catch (err) {
      this.$tracker.error(err)
    }
  }
}
</script>

<style>
</style>
